import { render, staticRenderFns } from "./TemplateLibrary.vue?vue&type=template&id=0dc643e6&scoped=true&"
import script from "./TemplateLibrary.vue?vue&type=script&lang=js&"
export * from "./TemplateLibrary.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLibrary.vue?vue&type=style&index=0&id=0dc643e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc643e6",
  null
  
)

export default component.exports